import { bool, func, object } from 'prop-types';

import { Modal, SanitizedHtml } from 'components';

import 'assets/styles/components/base/dialog/_modal.scss';

const LeavingConfirmationModal = ({ isOpen, modal, onClose }) => {
  return (
    <Modal
      size="medium"
      isOpen={isOpen}
      header={<div className="h2 underlined-yellow text-lg md:text-xl">{modal?.title}</div>}
      body={<SanitizedHtml content={modal?.content} className="text-sm lg:mb-4 lg:text-base" />}
      footer={
        <div className="flex-center-center flex-col gap-2 mt-4 md:flex-row md:flex-center-between">
          {modal?.backlinkText && (
            <button
              className="btn small outlined text-sm uppercase lg:text-base lg:py-3.5"
              onClick={onClose}
              type="button"
            >
              {modal.backlinkText}
            </button>
          )}

          {modal?.linkCta && (
            <a
              className="btn small text-sm uppercase lg:text-base lg:py-3.5"
              href={modal.linkCta.link}
              target="_blank"
              rel="noreferrer"
            >
              {modal.linkCta.buttonText}
            </a>
          )}
        </div>
      }
      onClose={onClose}
    />
  );
};

LeavingConfirmationModal.propTypes = {
  modal: object,
  isOpen: bool.isRequired,
  onClose: func.isRequired
};

export default LeavingConfirmationModal;
